"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enum = require("../../enum.js");
var _api = require("../api");
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    getList: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      cooperationStatusEnum: _enum.cooperationStatusEnum,
      ticketTypeEnum: _enum.ticketTypeEnum,
      settlementMethodEnum: _enum.settlementMethodEnum,
      //运营方式
      platformTypeEnum: _enum.platformTypeEnum,
      formRef: null,
      rules: {
        companyId: [{
          required: true,
          message: '请选择归属公司',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入客户名称',
          trigger: 'blur'
        }],
        loginAccount: [{
          required: true,
          message: '请输入登录账号',
          trigger: 'blur'
        }],
        loginPassword: [{
          required: true,
          message: '请输入登录密码',
          trigger: 'blur'
        }],
        creditAmount: [{
          required: true,
          message: '请输入授信金额',
          trigger: 'blur'
        }, {
          pattern: /^(?!0(\.0+)?$)([1-9]\d*(\.\d+)?|0\.[1-9]\d*)$/,
          message: '不能为0',
          trigger: 'blur'
        }]
      },
      dialogFormVisible: false,
      searchLoading: false,
      searchOptions: [],
      form: {
        ljcType: 2
      },
      userOption: [],
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      }
    };
  },
  methods: {
    open: function open(params) {
      console.log("编辑参数是....", params);
      if (params !== 'ADD') {
        this.form = _objectSpread({}, params);
      }
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.form = {};
      this.dialogFormVisible = false;
    },
    remoteMethod: function remoteMethod(query) {
      var _this = this;
      this.searchLoading = true;
      (0, _api.getCompanyOptionsApi)({
        name: query
      }).then(function (res) {
        _this.searchOptions = res.total ? res.list : res;
        _this.searchLoading = false;
      }).catch(function () {
        _this.$message.error('请求失败，请稍后再试');
        _this.searchLoading = false;
      });
    },
    handleUserSearch: function handleUserSearch(data) {
      var _this2 = this;
      this.throttle(function () {
        _this2.getSelectUser(data);
      }, 300)();
    },
    // 查询当前登陆人
    getSelectUser: function getSelectUser(keyWord) {
      var _this3 = this;
      this.userOption = [];
      suplierCouponsApi.getAllUser(keyWord).then(function (res) {
        _this3.userOption = res || []; //flag: 1表示当前登陆人
      });
    },
    submitForm: function submitForm() {
      var _this4 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this4.form.id ? _this4.request(_api.editCouponApi, '修改') : _this4.request(_api.addCouponApi, '添加');
        } else {
          return false;
        }
      });
    },
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(api, mes) {
        var _this5 = this;
        var params;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = _objectSpread(_objectSpread({}, this.form), {}, {
                customerType: 3
              });
              api(params).then(function () {
                _this5.$message.success("".concat(mes, "\u6210\u529F"));
                _this5.getList();
                _this5.close();
              }).catch(function () {
                _this5.$message.error('请求失败，请稍后再试');
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function request(_x, _x2) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  },
  created: function created() {
    this.remoteMethod();
    this.getSelectUser();
  }
};